import { PastDueReportModel } from '@core/models/reports/past-due-notice.model';

export const pastDueReportFake: PastDueReportModel[] = [];
